<template>
  <div>
    <template v-if="!loading">
      <template v-if="staffStatusList.length > 0">
        <div
          class="d-flex justify-space-between align-center boder-bottom"
        >
          <span
            class="title"
            style="margin-top: 25px;"
          >
            {{ '작업자 현황' | translate }}
          </span>
          <span>
            <v-switch
              v-model="showLocationConsent"
              dense
              hide-details
              :false-value="'N'"
              :true-value="'Y'"
              :label="'위치정보 사용 동의여부'|translate"
            />
          </span>
        </div>
        <!--작업자 작업현황-->
        <v-scroll-x-transition group>
          <v-row
            v-for="(item, index) in staffStatusList"
            :key="(item.staffId || ('index-' + index))+'-row'"
            v-ripple
            class="ma-0"
          >
            <work-status-item
              :item="item"
              :show-location-consent="showLocationConsent"
            />
          </v-row>
        </v-scroll-x-transition>
      </template>
      <template v-else>
        <div
          class="d-flex justify-space-between align-center"
        >
          <span
            class="title mb-5"
            style="margin-top: 25px;"
          >
            {{ '작업자가 없습니다' | translate }}
          </span>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import WindowComponent from "@/assets/plugins/mps-window-mobile/WindowComponent";
import {PATH} from "@/constants";
import WorkStatusItem from "@/components/widgets/as/WorkStatusItem";

export default {
  name: "WorkorderStatusWidget",
  components: {WorkStatusItem},
  extends: WindowComponent,
  mixins: [],
  data() {
    return {
      staffStatusList: [],
      loading: true,
      showLocationConsent: 'N'
    }
  },

  computed: {},

  created() {
    // this.loadWorkorderStaffStatus();
  },

  mounted() {
  },

  methods: {
    async loadWorkorderStaffStatus() {
      // this.loading = true;
      try {
        const response = await this.$request(PATH.MAP_APP.GET_ALL_WORKER)
          .setObject({})
          .enqueue();
        const mapped = response.data.map(item => {
          return {
            ...item,
            allCnt: ((item.asWaitCnt || 0) + (item.asProcCnt || 0) + (item.asDayFinishCnt || 0) + (item.asDayCancelCnt || 0)),
          }
        })

        const sorted = mapped.sort((a, b) => {
          return b.allCnt - a.allCnt;
        });
        const {userId} = this.user;
        const sortAndFilterList = sorted
          .reduce((acc, e) => {
            e.userId === userId ? acc.unshift(e) : acc.push(e);
            return acc;
          }, []);
        this.staffStatusList = sortAndFilterList.length ? sortAndFilterList : sorted;
      } catch (error) {
      }
      this.loading = false;
    },

    refresh() {
      this.loadWorkorderStaffStatus();
    },
  }
}
</script>

<style scoped>
.ptr-handle {
  height: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  align-items: flex-end;
  border: magenta 1px solid;
}
</style>
